module.exports = __webpack_public_path__ + "img/link02.506f5082.png";